import {
  closeModalSafely as closeModalSafelyBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  targetTable,
  isEditMode,
  setIsSubmitting,
  setTargetTable,
  closeModal,
  fetch,
  createMultipleTables,
) => {
  if (!errors?.length > 0) {
    let bulkValues = null;

    if (createMultipleTables) {
      bulkValues = { bulk: [] };
      const start = values?.startingNumber;
      const end = values?.endingNumber;

      if (start >= end) {
        throw new Error(
          'startingNumber cannot be greater than or equal to endingNumber',
        );
      }

      for (let i = start; i <= end; i++) {
        bulkValues.bulk.push({
          ...values,
          name: values.name + i,
          startingNumber: undefined,
          endingNumber: undefined,
        });
      }
    }

    handleSubmitBase(
      createMultipleTables ? 'tables/bulk' : 'tables',
      'editTableSuccess',
      'editTableError',
      'createNewTableSuccess',
      'createNewTableError',
      event,
      errors,
      bulkValues || values,
      targetTable,
      isEditMode,
      setIsSubmitting,
      setTargetTable,
      closeModal,
      fetch,
    );
  }
};
